import { Box, Button, Drawer } from '@mantine/core';
import { useElementSize } from '@mantine/hooks';
import otpSlice from '@reducers/otp';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../stores';
import OTPDialogComponent from './otpInput';
import PhoneNumberDialogComponent from './phoneNumberInput';

interface Props {
  isVisible: boolean;
  setIsVisible: Function;
}

const LoginDrawer = ({ isVisible, setIsVisible }: Props) => {
  const { height, ref } = useElementSize();
  const { userId } = useSelector((state: RootState) => state.otp);
  const dispatch = useDispatch();

  let modalData = <PhoneNumberDialogComponent />;
  if (userId) {
    modalData = <OTPDialogComponent setIsOpen={setIsVisible} />;
  }

  return (
    <Drawer.Root
      position="bottom"
      transitionProps={{ transition: 'slide-up' }}
      size={height + 100}
      opened={isVisible}
      dir="ltr"
      onClose={() => setIsVisible(false)}
    >
      <Drawer.Overlay />
      <Drawer.Content>
        <Drawer.Header>
          <Drawer.CloseButton />

          <Drawer.Title>
            {userId ? (
              <Button variant="subtle" onClick={() => dispatch(otpSlice.actions.clearUserId())} size="compact-sm">
                ویرایش شماره
              </Button>
            ) : null}
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <Box ref={ref} dir="rtl">
            {modalData}
          </Box>
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  );
};

export default LoginDrawer;
